<template>
  <div>
    <b-modal id="reassign-value-modal" ref="reassignValueModal" hide-footer @hidden="hide">
      <p class="back-variable-button" :class="{ disabled: disableReviewReassignValue }" @click="backToCreateModal"><img src="static/img/activity-configurator/arrow-left.svg" alt="" class="back_arrow" /><span>Back to Create Variable</span></p>
      <template slot="modal-title">Reassign Values</template>
      <div class="formula-input-container" :class="{ disabled: disableReviewReassignValue }">
        <div class="edit-variable-name">
          <p v-if="(reassignValueAssign.name == '') || (reassignValueAssign.name != '' && showErrorData.length > 0) || (this.isEditingVariableName)">New Variable</p>
          <div v-if="isEditingVariableName" class="save-variable-wrap">
            <input class="form-control input-variable-name" v-model.trim="reassignNewVariableName" ref="inputVariableName" type="text" autofocus="autofocus" />
            <b-button data-testid="save-variable" variant="primary" :disabled="disableVariableSaveBtn" @click="updateVariable()"><i class="fa fa-check fs-24" aria-hidden="true"></i></b-button>
            <b-button data-testid="cancel-variable" class="btn-cancel" :disabled="disableVariableSaveBtn" @click="cancelVariable()"><img src="static/img/cross.svg" alt="Cross icon"/></b-button>
          </div>
          <div v-else>
            <div class="save-variable-wrap" v-if="reassignValueAssign.name == ''">
              <input class="form-control input-variable-name default-variable-name" v-model.trim="reassignNewVariableName" ref="inputVariableName" type="text" autofocus="autofocus" placeholder="Enter Variable Name" @click="editVariable" />
              <b-button data-testid="save-variable" variant="primary" :disabled="disableVariableSaveBtn" @click="updateVariable()"><i class="fa fa-check fs-24" aria-hidden="true"></i></b-button>
              <b-button data-testid="cancel-variable" class="btn-cancel" :disabled="disableVariableSaveBtn" @click="cancelVariable()"><img src="static/img/cross.svg" alt="Cross icon"/></b-button>
              <span v-if="showErrorData.length > 0" class="error-message">{{ errorMessage }}</span>
            </div>
            <div class="save-variable-wrap" v-else-if="reassignValueAssign.name != '' && showErrorData.length > 0">
              <input class="form-control input-variable-name default-variable-name" v-model.trim="reassignNewVariableName" ref="inputVariableName" type="text" autofocus="autofocus" placeholder="Enter Variable Name" @click="editVariable" />
              <b-button data-testid="save-variable" variant="primary" :disabled="disableVariableSaveBtn" @click="updateVariable()"><i class="fa fa-check fs-24" aria-hidden="true"></i></b-button>
              <b-button data-testid="cancel-variable" class="btn-cancel" :disabled="disableVariableSaveBtn" @click="cancelVariable()"><img src="static/img/cross.svg" alt="Cross icon"/></b-button>
              <span v-if="showErrorData.length > 0" class="error-message">{{ errorMessage }}</span>
            </div>
            <div v-else class="variable-name">
              <div class="show-var-name" :class="{ 'd-none': isReassignVariableName && !this.newVariableList.reassignedValueVariable }">
                <span>New Variable = </span>
                <span class="update-variabe-name">{{ reassignValueAssign.name }}</span>
                <span data-testid="edit-variable" class="edit-icon ml-8 mr-8" @click="editVariable"><i class="fa fa-pencil edit_hover_class fs-18" style="color: #4c8ce4;" aria-hidden="true"> </i> </span>
              </div>
              <div class="reassign-table-wrap">
                <div class="reassign-value-table">
                  <div class="reassign-value-table-title">
                    <h4>
                      <span>IF</span> Raw Score =
                    </h4>
                    <h4>
                      <span>THEN</span> Reassigned Value =
                    </h4>
                  </div>
                  <table v-if="reassignValuesList">
                    <tr v-for="(value, index) in reassignValuesList" :key="index">
                      <td class="position-relative">
                        <input type="number" :class="value.error ? 'input-error' : ''" autofocus="autofocus" placeholder="Enter Value" @input="checkDuplicateValue(value, index)" v-model="value.score" />
                        <span class="validation-error" v-if="value.error">{{ value.error }}</span>
                      </td>
                      <td><input type="number" autofocus="autofocus" placeholder="Enter Value" v-model="value.reassigned_value" /></td>
                      <button @click="removeRow(index)"><i class="fa fa-trash fs-20" aria-hidden="true" style="color: #abb4b9;"></i></button>
                    </tr>
                    <button @click="addRow">+ Add Row</button>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="footer" :class="{ 'disable-modal-footer': isEditingVariableName }">
          <div class="my-auto text-right">
            <b-button class="btn-cancel" @click="hide()">
              Cancel
            </b-button>
            <b-button :disabled="isReassignedSaveDisabled" variant="primary" @click="saveReassignedValues()">
              Save Reassigned Values
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import studyActivityCommon from "@/components/configurator/study-activities-mixin";
export default {
  name: "reassign-value-modal-component",
  data() {
    return {
      isEditingVariableName: false,
      reassignNewVariableName: "",
      reassignValueAssign: {
        name: ""
      },
      reassignedVariableName: "",
      reassignValuesList: [
        {
          score: null,
          reassigned_value: null
        }
      ],
      disableReviewReassignValue: false,
      isReassignVariableName: false,
      errorMessage: '',
      showErrorData: []
    };
  },
  props: {
    newVariableList: {
      type: Object
    },
    variablesListData: {
      type: Array
    }
  },
  mixins: [studyActivityCommon],
  computed: {
    disableSaveButton() {
      //This computed property will handle enabling/disabling of save button
      return false;
    },
    disableVariableSaveBtn() {
      if (!this.reassignNewVariableName || this.reassignNewVariableName == "") {
        return true;
      }
      return false;
    },
    isReassignedSaveDisabled() {
      for (const value of this.reassignValuesList) {
        if ((!value.score || !value.reassigned_value) || value.error || this.showErrorData.length > 0 || this.isEditingVariableName) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    checkDuplicateValue(value, index) {
      let emptyObject = this.reassignValuesList.some(function(el) {
        return el.score === '';
      });
      this.reassignValuesList = this.reassignValuesList.map(obj => {
        if (Number.isInteger(obj.score)) {
          obj.score = parseInt(obj.score);
        } else {
          const hasDecimal = obj.score.includes(".");
          const decimalValue = (hasDecimal ? obj.score.split(".") : [obj.score, ""])[1];
          const parsed = parseFloat(obj.score).toFixed(decimalValue.length);
          obj.score = isNaN(parsed) ? "" : parsed;
        }
        return obj;
      })
      let isDuplicate = _.filter(this.reassignValuesList, ['score', value.score]);
      if (isDuplicate && isDuplicate.length > 1) {
        this.$set(this.reassignValuesList[index], "error", "No duplicates should be allowed.");
      } else {
        emptyObject = true;
        delete this.reassignValuesList[index].error;
      }
      this.reassignValuesList.map(obj=> {
        if (obj.score === '' && obj.error) {
          delete obj.error;
        }
        return obj;
      })
      this.resetErrors(emptyObject);
    },
    resetErrors(emptyObject) {
      let resetErrorMessage = this.reassignValuesList.filter((object, index) => {
        return this.reassignValuesList.find((x, ind)=> x.score === object.score && index !== ind )
      })
      if (emptyObject) {
        this.reassignValuesList.map(object => {
          if (resetErrorMessage.indexOf(object) === -1) {
            if (object.error) {
              delete object.error
            }
          }
        })
      }
      if(resetErrorMessage.length === 0) {
        this.reassignValuesList.map(obj => {
          delete obj.error
        })
      }
    },
    show(reassignObject = null, data = null) {
      this.disableReviewReassignValue = false;
      this.reassignValueAssign.name = "";
      this.$refs.reassignValueModal.show();
      if (reassignObject && data) {
        this.reassignValueAssign.name = data && data.reassignedValueVariable;
        if(data && data.reassignedMapping){
          this.reassignValuesList = _.cloneDeep(data.reassignedMapping);
        }
        this.disableReviewReassignValue = false;
        this.isReassignVariableName = true;
        this.$refs.reassignValueModal.show();
      }
    },
    hide() {
      this.emptyVariableName();
      this.showErrorData =  [];
      this.errorMessage = '';
      this.$refs.reassignValueModal.hide();
    },
    editVariable() {
      this.reassignNewVariableName = this.reassignValueAssign.name;
      this.isEditingVariableName = true;
      this.$nextTick(() => this.$refs.inputVariableName.focus());
    },
    emptyVariableName() {
      this.reassignNewVariableName = "";
      this.reassignValueAssign.name = "";
      this.isReassignVariableName = false;
      this.reassignValuesList = [{ score: null, reassigned_value: null }];
    },
    updateVariable() {
      this.reassignValueAssign.name = this.reassignNewVariableName;
      this.isEditingVariableName = false;
      this.showErrorData = this.variablesListData.filter(item => item.name.toLowerCase() === this.reassignNewVariableName.toLowerCase());
      if(this.showErrorData){
        this.errorMessage = 'Variable name already used. Please choose a different name.';
      }
      else{
        this.errorMessage = '';
      }
    },
    cancelVariable() {
      this.isEditingVariableName = false;
      this.showErrorData =  [];
      this.errorMessage = '';
      this.emptyVariableName();
    },
    addRow() {
      this.reassignValuesList.push({
        score: "",
        reassigned_value: ""
      });
    },
    removeRow(index) {
      let filterDuplicate = []
      if (this.reassignValuesList[index]) {
        filterDuplicate = _.filter(this.reassignValuesList, {'score': this.reassignValuesList[index].score, 'error': 'No duplicates should be allowed.'});
      }
      if (this.reassignValuesList.length > 1) {
        this.reassignValuesList.splice(index, 1);
        if (filterDuplicate.length !== 0) {
          let objIndex = this.reassignValuesList.findIndex(x => x.score === filterDuplicate[0].score);
          delete this.reassignValuesList[objIndex].error;
        }
        this.resetErrors(false);
      }
    },
    backToCreateModal() {
      let reassignValueData = {
        variableData: this.newVariableList,
        reassignData: ""
      };
      this.$root.$emit("showVariableCalculationModal", reassignValueData);
    },
    saveReassignedValues() {
      let reassignValueData = {
        reassignedVariableName: this.reassignValueAssign.name,
        variableData: this.newVariableList,
        reassignData: this.reassignValuesList
      };
      this.$root.$emit("showVariableCalculationModal", reassignValueData);
    }
  }
};
</script>

<style lang="scss">
#reassign-value-modal {
  @media (min-width: 992px) {
    .modal-dialog {
      min-width: 599px;
      vertical-align: middle;
    }
  }

  .modal-content {
    .back-variable-button {
      color: #4c8ce4;
      font-size: 16px;
      font-family: Roboto-Medium;
      position: absolute;
      left: 2rem;
      top: -70px;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        position: relative;
        height: 16px;
      }

      span {
        margin-left: 10px;
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }

    .modal-header {
      border-bottom: 0;
      color: #4a4a4a;
      padding: 62px 32px;
      padding-bottom: 0;
      font-family: Roboto-Medium;

      h5 {
        font-size: 1.375rem;
      }

      .close {
        opacity: 1;
        font-size: 30px;
        color: #666669;
        padding: 12px;
        position: relative;
        top: -37px;
      }
    }

    .modal-body {
      padding: 0;
      padding-top: 5px;
      font-size: 14px;
      color: #4a4a4a;

      .btn {
        &:active {
          background: none;
          border: none;
        }

        &:focus {
          box-shadow: none;
        }
      }

      .formula-input-container {
        font-size: 14px;
        padding: 2rem;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }

        .variable-name {
          color: #666669;
          margin-bottom: 12px;

          .show-var-name {
            word-break: break-all;
            font-family: Roboto-Medium;

            .update-variabe-name {
              color: #4c8ce4;
            }
          }

          .reassign-table-wrap {
            width: 100%;
            margin-top: 16px;

            .reassign-value-table {
              border: 1px solid #e4e8eb;
              border-radius: 4px;

              .reassign-value-table-title {
                display: flex;
                justify-content: space-between;
                padding: 8px 16px;
                box-sizing: border-box;
                border-bottom: 1px solid #e4e8eb;

                h4 {
                  color: #666669;
                  font-size: 12px;
                  font-family: RobotoRegular;
                  font-weight: bold;
                  width: 50%;
                  float: left;
                  span {
                    font-weight: normal;
                  }
                }
              }
            }

            table {
              width: 100%;
              max-height: 250px;
              overflow: auto;
              display: block;

              tr {
                display: flex;
                justify-content: space-between;

                td {
                  input {
                    border: solid 1px #4c8ce4;
                    background-color: #f5f8fa;
                    border-radius: 4px;
                    color: #666669;
                    padding: 2px;
                    height: 36px;
                    padding-left: 12px;
                    width: 184px;
                    margin: 8px 16px;
                    box-sizing: border-box;
                    text-align: right;
                    padding-right: 12px;
                  }
                }

                .input-error {
                  border: solid 1px #f16559;
                  box-shadow: none;
                }
                .validation-error {
                  font-size: 12px;
                  position: absolute;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.33;
                  letter-spacing: normal;
                  text-align: left;
                  color: #f16559;
                  width: 100%;
                  bottom: -10px;
                  left: 16px;
                  margin-bottom: 2px;
                }

                button {
                  border: none;
                  background: transparent;
                  cursor: pointer;
                }
              }

              button {
                border: none;
                background: transparent;
                cursor: pointer;
                color: #4c8ce4;
                font-size: 14px;
                background: transparent;
                border: none;
                font-family: Roboto-Bold;
                padding: 0;
                margin: 8px 16px;
              }
            }
          }
        }

        .edit-variable-name {
          margin-bottom: 16px;

          p {
            font-size: 14px;
            color: #666669;
            padding-bottom: 8px;
            margin-bottom: 0px;
            font-family: Roboto-Medium;
          }

          .save-variable-wrap {
            display: flex;
            vertical-align: middle;
            align-items: normal;
            position: relative;

            button {
              font-size: 14px;

              &.btn-primary {
                background-color: rgba(72, 191, 122, 0.3);
                border-color: rgba(72, 191, 122, 0.3);
                border-radius: 4px;
                padding: 0;
                margin-left: 12px;
                width: 38px;
                height: 38px;

                &:disabled {
                  opacity: 0.4;
                  cursor: no-drop;
                }

                &:focus {
                  box-shadow: none;
                }

                i {
                  color: #17974d;
                  position: relative;
                  top: 1px;
                }
              }

              &.btn-cancel {
                background: rgba(224, 224, 224, 0.5);
                margin-left: 8px;
                border: 0;
                padding: 0;
                width: 38px;
                height: 38px;

                img {
                  height: 16px;
                  width: 16px;
                }

                &:active {
                  background: none;
                  border: none;
                }

                &:focus {
                  box-shadow: none;
                }
              }
            }

            .error-message{
              font-size: 13px;
              font-weight: 500;
              color: #f16559;
              position: absolute;
              bottom: -23px;
            }
          }
        }

        .edit-icon {
          cursor: pointer;
        }

        .input-variable-name {
          border: solid 1px #4c8ce4;
          background-color: #f5f8fa;
          border-radius: 4px;
          color: #666669;
          padding: 2px;
          height: 36px;
          padding-left: 12px;
          width: 83%;
        }
      }

      .footer {
        padding: 0rem 2rem 2rem;

        button {
          font-size: 14px;

          &.btn-primary {
            background-color: #4c8ce4;
            border-color: #4c8ce4;
            border-radius: 4px;
            padding: 7px 16px;
            font-family: Roboto-Bold;

            &:hover {
              background-color: #34537d;
              border-color: #34537d;
            }

            &:disabled {
              opacity: 0.4;
              pointer-events: none;
            }

            &:focus {
              box-shadow: none;
            }
          }

          &.btn-cancel {
            padding: 8px 24px;
            color: #666669;
            background: none;
            border: 0;
            font-family: Roboto-Medium;

            &:hover {
              color: #4a4a4a;
              background: none;
              border: none;
              padding: 8px 24px;
              outline: none;
              box-shadow: none;
            }

            &:active {
              background: none;
              border: none;
            }

            &:focus {
              box-shadow: none;
            }

            &:disabled {
              opacity: 0.4;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 4px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #e4e8eb;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
